import { render, staticRenderFns } from "./TaxPeriodGrid.vue?vue&type=template&id=7802995b"
import script from "./TaxPeriodGrid.vue?vue&type=script&lang=js"
export * from "./TaxPeriodGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports